import React, { useContext, useEffect, useMemo, useRef, useState, } from 'react';
var RudderstackContext = React.createContext(undefined);
export var RudderstackProvider = function (_a) {
    var children = _a.children, configUrl = _a.configUrl, dataplaneUrl = _a.dataplaneUrl, writeKey = _a.writeKey, enabled = _a.enabled, allowedConsent = _a.allowedConsent, deniedConsent = _a.deniedConsent;
    var _b = useState(undefined), analytics = _b[0], setAnalytics = _b[1];
    var isLoading = useRef(false);
    // biome-ignore lint/correctness/useExhaustiveDependencies: We only care about enabled, allowedConsent, and deniedConsent.
    useEffect(function () {
        if (enabled && !analytics && !isLoading.current) {
            isLoading.current = true;
            Promise.all([
                import('@rudderstack/analytics-js/bundled'),
                import('./generated'),
            ]).then(function (_a) {
                var RudderAnalytics = _a[0].RudderAnalytics, RudderTyperAnalytics = _a[1].RudderTyperAnalytics;
                var analyticsInstance = new RudderAnalytics();
                analyticsInstance.load(writeKey, dataplaneUrl, {
                    configUrl: configUrl,
                    consentManagement: {
                        enabled: true,
                        provider: 'custom',
                        allowedConsentIds: allowedConsent,
                        deniedConsentIds: deniedConsent,
                    },
                });
                RudderTyperAnalytics.setRudderTyperOptions({
                    analytics: analyticsInstance,
                });
                setAnalytics(RudderTyperAnalytics);
                isLoading.current = false;
            });
        }
        if (!enabled && analytics) {
            setAnalytics(undefined);
            isLoading.current = false;
        }
    }, [enabled, allowedConsent, deniedConsent]);
    var contextValue = useMemo(function () {
        if (!analytics)
            return { RudderstackClient: undefined };
        return { RudderstackClient: analytics };
    }, [analytics]);
    return (React.createElement(RudderstackContext.Provider, { value: contextValue }, children));
};
export function useRudderstackClient() {
    var context = useContext(RudderstackContext);
    if (context === undefined) {
        throw new Error('RudderstackContext used outside of its Provider!');
    }
    return context;
}
